import Lottie from 'lottie-react';

import lottieCurrentAndPastAppt from '../jsons/current-and-past-appointments.json';

const LottieCurrentAndPastAppt = props => {
  return <Lottie animationData={lottieCurrentAndPastAppt} loop={false} {...props} />;
};

export default LottieCurrentAndPastAppt;
